import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { dowloadQrCode } from "../../../../redux/features/qrCodesSlice";
import { Icon } from "@iconify/react";

const DownloadQrCode = ({ id, name }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.qrCodes);

  const handleDownload = () => {
    dispatch(dowloadQrCode(id)).then((res) => {
      console.log(res.payload);

      if (!res.payload) return;

      const url = window.URL.createObjectURL(
        new Blob([res.payload], { type: "image/png" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}.png`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    });
  };

  return (
    <Button
      startIcon={
        <Icon icon="line-md:download-outline-loop" width="24" height="24" />
      }
      onClick={handleDownload}
      size="small"
      disabled={loading}
    >
      {loading ? "Downloading..." : "Download"}
    </Button>
  );
};

export default DownloadQrCode;
